/**
 * ─────────────────────────────────────────────────────────────────────────────
 * @module  public/js/utils/date-utils.js
 * @summary Tiny helpers for date arithmetic that respect business days.
 *
 * @description
 * Add N working days (Mon-Fri) to a Date
 * and return an ISO string at 17:00 local time.
 *
 * @param {Date} start
 * @param {number} days
 * @returns {string} ISO-8601 eg "2025-05-12T17:00:00-04:00"
 *
 * @author   TopSail AI
 * @version  1.0.0
 * @since    2025-05-09
 * ─────────────────────────────────────────────────────────────────────────────
 */

export function addBusinessDayTimestamp(start = new Date(), days = 0) {
  const d = new Date(start);
  let left = days;

  while (left > 0) {
    d.setDate(d.getDate() + 1);
    const w = d.getDay(); // 0=Sun … 6=Sat (local)
    if (w !== 0 && w !== 6) left -= 1;
  }

  // set time to 17:00 local (5 PM)
  d.setHours(17, 0, 0, 0);
  return d.toISOString(); // keeps timezone offset
}
